import ComponentCard from './ComponentCard';

export default ComponentCard;
